/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '@/utils/contextManager';
import { getBooleanValue, getStudioHistory, setStudioHistory } from '../../utils';

const CloseIcon = (props) => (
  <svg
    className={props.className}
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="close-circle"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
  </svg>
);

const SearchPage = (props) => {
  const { value, handleSearch = () => {} } = props;

  const history = getStudioHistory();

  const [histories, setHistories] = useState(history || []);

  const { setDrawer } = useContext(MyContext);

  const [keyValue, setKeyValue] = useState(value || '');

  const handelChange = (e) => {
    e.persist();
    setKeyValue(e.target.value);
  };

  const handleOk = () => {
    handleSearch(keyValue, handleClear);
    setDrawer();
  };

  const handleClear = () => {
    setKeyValue('');
    handleSearch('');
  };

  useEffect(() => {
    setStudioHistory(histories);
  }, [histories]);

  return (
    <div
      className="search"
      style={getBooleanValue('IS_IMMERSE', false) ? { paddingTop: '6vw', height: '18vw' } : null}
    >
      <div className="search-input-wrapper">
        <div className="search-input">
          <em className="iconSearch" />
          <input
            type="text"
            placeholder="输入关键词搜索"
            onChange={handelChange}
            value={keyValue}
          ></input>
          {keyValue !== '' && (
            <span
              onClick={() => {
                setKeyValue('');
              }}
            >
              <CloseIcon className={'search-input-close'}></CloseIcon>
            </span>
          )}
        </div>
        <div
          className="searchBtn"
          onClick={() => {
            if (keyValue) {
              if (histories.indexOf(keyValue) > -1) {
                histories.splice(histories.indexOf(keyValue), 1);
              }
              histories.unshift(keyValue);
              setHistories([...histories]);
            }
            handleOk();
          }}
        >
          搜索
        </div>
      </div>
      {histories && histories.length > 0 && (
        <div className="search-history">
          <div className="search-history-title">
            <span>搜索历史</span>
            <em
              className="iconDelete"
              onClick={() => {
                setHistories([]);
              }}
            />
          </div>
          <div className="search-history-content">
            {histories.map((item, index) => (
              <div
                key={`search-history-${index}`}
                className="history-item"
                onClick={() => {
                  setKeyValue(item);
                }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPage;
